import React, { useEffect, useState } from "react";

const VersionChecker = () => {
    /* cache bust first implementation */
    // const [version, setVersion] = useState(null);

    // useEffect(() => {
    //     fetch(`/version.txt?timestamp=${new Date().getTime()}`)
    //         .then(response => response.text())
    //         .then(text => setVersion(text.trim()));
    // }, []);

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         fetch(`/version.txt?timestamp=${new Date().getTime()}`)
    //             .then(response => response.text())
    //             .then(text => {
    //                 if (text.trim() !== version) {
    //                     window.location.reload(true);
    //                 }
    //             });
    //     }, 6000);

    //     return () => clearInterval(interval);
    // }, [version]);

    // return null;

    /* cache bust second implementation */
    const [currentVersion, setCurrentVersion] = useState(null);

    /* get main file name */
    const getCurrentMainJsName = () => {
        const scripts = document.querySelectorAll('script[src]');
        for (let script of scripts) {
            const src = script.getAttribute('src');
            if (src.includes('main.') && src.endsWith('.js')) {
                return src.split('/').pop();
            }
        }
        return null;
    };

    useEffect(() => {
        const currentMainJsVersion = getCurrentMainJsName();
        setCurrentVersion(currentMainJsVersion);
    });

    useEffect(() => {
        const interval = setInterval(() => {
            fetch(`/version.txt?timestamp=${new Date().getTime()}`)
                .then(response => response.text())
                .then(text => {
                    const lastVersion = text.trim();
                    if (lastVersion !== currentVersion) {
                        window.location.reload(true);
                    }
                });
        }, 6000);

        return () => clearInterval(interval);
    }, [currentVersion]);

    return null;
};

export default VersionChecker;